export default __webpack_public_path__ + "static/media/Emotional03.6f0e6593.png";